import React, { useRef, useState } from "react";
import { UploadSimple, Spinner } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";
import i18next from 'i18next'

export default function FileUpload({ propertyId = "", category = "photo", onUploaded, label = i18next.t('dragDropOrClickToUpload', 'Drag & drop or click to upload'), accept, allowedExt }) {
  const inputRef = useRef(null);
  const [drag, setDrag] = useState(false);
  const [busy, setBusy] = useState(false);

  const upload = async (files) => {
    if (!files || files.length === 0) return;
    const list = Array.from(files);
    if (allowedExt && allowedExt.length) {
      const bad = list.find((f) => !allowedExt.includes((f.name.split(".").pop() || "").toLowerCase()));
      if (bad) { toast.error(i18next.t('unsupportedFileType', 'Unsupported file type')); return; }
    }
    setBusy(true);
    try {
      let pending = false;
      for (const file of list) {
        const fd = new FormData();
        fd.append("file", file);
        fd.append("category", category);
        fd.append("property_id", propertyId);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        if (data?.pending_approval) pending = true;
        onUploaded && onUploaded(data);
      }
      if (pending) toast.info(i18next.t('perm.uploadPending', 'Upload complete — pending Admin approval before it can be shared externally.'));
      else toast.success(i18next.t('uploadComplete', 'Upload complete'));
    } catch (e) {
      toast.error(e?.response?.data?.detail || i18next.t('uploadFailed', 'Upload failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); upload(e.dataTransfer.files); }}
      onClick={() => inputRef.current?.click()}
      data-testid="file-upload"
      className={`cursor-pointer border-2 border-dashed rounded-sm p-8 text-center transition-colors ${
        drag ? "border-[#C5A059] bg-[#C5A059]/5" : "border-slate-300 hover:border-[#C5A059]"
      }`}
    >
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={accept}
        className="hidden"
        onChange={(e) => upload(e.target.files)}
      />
      {busy ? (
        <Spinner size={28} className="mx-auto animate-spin text-[#0B2545]" />
      ) : (
        <UploadSimple size={28} className="mx-auto text-slate-400" />
      )}
      <p className="text-sm text-slate-500 mt-2">{busy ? i18next.t('uploading', 'Uploading…') : label}</p>
    </div>
  );
}
